"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChart = void 0;
var drawPlane_1 = require("../parse/drawPlane");
var getPlanes_1 = require("../parse/getPlanes");
var getIndexNearest_1 = require("../../common/getIndexNearest");
var createSvg_1 = require("../createSvg");
var LineChart = function (svg, config) {
    var thickness = config.thickness || 6;
    var _a = getPlanes_1.getPlanes(config), dataPointGroup = _a.dataPointGroup, yAxisMarks = _a.yAxisMarks, destPlane = _a.destPlane;
    var dataPointGroup2 = dataPointGroup;
    var innerPaddingStart = config.xAxis.innerPaddingStart || 0;
    drawPlane_1.drawPlane(svg, config, dataPointGroup2[0], yAxisMarks, destPlane);
    var getPaths = function (points, values, thickness, ignoreZeroPoint) {
        var path = points.map(function (it) { return "L " + (innerPaddingStart + it[0] + thickness / 2) + " " + it[1]; }).join(' ');
        var lines = [];
        if (ignoreZeroPoint) {
            // First segment: Dotted line if zero
            var firstValueIndex_1 = values.series.findIndex(function (it) { return Number(it) !== 0; });
            if (firstValueIndex_1 !== 0) {
                var firstSegment = points.filter(function (it, i) { return i <= firstValueIndex_1; })
                    .map(function (it) { return "L " + (innerPaddingStart + it[0] + thickness / 2) + " " + points[firstValueIndex_1][1]; }).join(' ');
                lines.push({
                    type: 'dotted',
                    path: "M" + firstSegment.substr(1)
                });
            }
            // Middle segment: ignore point if zero
            path = points.filter(function (it, i) { return values.series[i] !== 0; })
                .map(function (it) { return "L " + (innerPaddingStart + it[0] + thickness / 2) + " " + it[1]; }).join(' ');
            lines.push({
                type: 'solid',
                path: "M" + path.substr(1)
            });
            // Last segment: Dotted line if zero
            var lastValueIndex_1 = values.series.length - 1 - __spreadArrays(values.series).reverse().findIndex(function (it) { return Number(it) !== 0; });
            if (lastValueIndex_1 !== values.series.length - 1) {
                var lastSegment = points.filter(function (it, i) { return i >= lastValueIndex_1; })
                    .map(function (it) { return "L " + (innerPaddingStart + it[0] + thickness / 2) + " " + points[lastValueIndex_1][1]; }).join(' ');
                lines.push({
                    type: 'dotted',
                    path: "M" + lastSegment.substr(1)
                });
            }
        }
        else {
            path = points.map(function (it) { return "L " + (innerPaddingStart + it[0] + thickness / 2) + " " + it[1]; }).join(' ');
            lines.push({
                type: 'solid',
                path: "M" + path.substr(1)
            });
        }
        return lines;
    };
    dataPointGroup2.forEach(function (points, k) {
        var values = config.values[k];
        var lines = getPaths(points, values, thickness, config.yAxis.ignoreZeroPoint || false);
        lines.map(function (line) {
            var p = svg.path(line.path).fill('transparent');
            if (line.type === 'solid') {
                p.stroke({ color: config.values[k].color, width: 3 });
            }
            else {
                p.stroke({ color: config.values[k].color, width: 3, dasharray: '10 5' });
            }
        });
        var circleColor = config.values[k].color3 ? config.values[k].color3 : config.values[k].color;
        var circleSize = config.values[k].size || 0;
        var circlePoints = points;
        if (config.yAxis.ignoreZeroPoint) {
            circlePoints = circlePoints.filter(function (it, i) { return config.values[k].series[i] !== 0; });
        }
        circlePoints.map(function (it) { return svg.circle(circleSize).fill(circleColor).move(innerPaddingStart + it[0] + thickness / 2 - circleSize / 2, it[1] - circleSize / 2); });
    });
    // Draw select verticle line
    if (config.selectedIndex > -1 && dataPointGroup2.length && dataPointGroup2[0][config.selectedIndex]) {
        var selectLine = destPlane[1];
        var newX = Math.floor(dataPointGroup2[0][config.selectedIndex][0] + thickness / 2) + innerPaddingStart;
        selectLine[0][0] = newX;
        selectLine[1][0] = newX;
        svg.line(selectLine).stroke({ color: config.selectedLineColor, width: 1 });
    }
    // Draw select circle
    if (config.selectedIndex > -1 && dataPointGroup2.length && dataPointGroup2[0][config.selectedIndex]) {
        dataPointGroup2.forEach(function (points, k) {
            var it = points[config.selectedIndex];
            var circleSize2 = config.values[k].size ? Number(config.values[k].size) + 4 : 14;
            var circleColor2 = config.values[k].color2 ? config.values[k].color2 : config.values[k].color;
            if (config.values[k].series[config.selectedIndex] === 0 && config.yAxis.ignoreZeroPoint) { }
            else {
                svg.circle(circleSize2).fill(config.backgroundColor || '#fff').stroke({ color: circleColor2, width: 3 }).move(innerPaddingStart + it[0] + thickness / 2 - circleSize2 / 2, it[1] - circleSize2 / 2);
            }
        });
    }
    var getXY = function (x, y) {
        var nearest = getIndexNearest_1.getIndexNearest(dataPointGroup2, 1, x, y);
        return nearest;
    };
    var getDataPointGroup = function () { return dataPointGroup2; };
    var getPopupInfo = function (i) {
        return {
            title: config.xAxis.series[i],
            rows: config.values.map(function (it, j) {
                var color = config.values[j].color;
                var title = config.yAxis.label2 ? config.yAxis.label2 : config.yAxis.label;
                var value = createSvg_1.comma(config.values[j].series[i]);
                return { color: color, title: title, value: value };
            })
        };
    };
    return { svg: svg, getXY: getXY, getDataPointGroup: getDataPointGroup, getPopupInfo: getPopupInfo };
};
exports.LineChart = LineChart;
